
import {ServiceModule} from './service-module';
import {MessageTypes} from '../enums/message-types.enum';

export class ServiceMessage {

  public MessageType: MessageTypes;
  public ServiceModul: ServiceModule;
}
